"use client";

// src/errorBoundaryUtils.ts
import * as React from "react";
import { shouldThrowError } from "./utils.js";
var ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
var useClearResetErrorBoundary = errorResetBoundary => {
  React.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
var getHasError = _ref => {
  let {
    result,
    errorResetBoundary,
    throwOnError,
    query
  } = _ref;
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && shouldThrowError(throwOnError, [result.error, query]);
};
export { ensurePreventErrorBoundaryRetry, getHasError, useClearResetErrorBoundary };